<template v-slot:append>
  <v-dialog max-width="95%" persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="95%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          紐づけ可能貨物検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-expansion-panels v-model="expansionPanel" multiple flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row ref="_calcHeight-Row1">
                  <v-col :cols="12">
                    <dd-sub-header>
                      検索条件
                    </dd-sub-header>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row no-gutters align-content="center" ref="_calcHeight-Row1">
                  <v-col :cols="3" class="px-1">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12">
                        <dd-code-text-box
                          label="営業所コード/名称"
                          v-model="conditions.eigyosho"
                          ref="eigyosho"
                          :length="100"
                          :readonly="false"
                          :valueType="Ctrls.InputTypes.Alphanumeric"
                          titleText="営業所検索"
                          :headerList="eigyoshoHeader"
                          item-value="eigyoshoCd"
                          item-text="eigyoshoNm"
                          :itemList="filteredMstEigyoshoList"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols=3 class="px-1">
                    <v-row no-gutters align-content="center">
                      <div style="width:47%" class="px-1">
                        <dd-date-box
                          label="積日"
                          v-model="conditions.hatsuchiYmdFrom"
                          ref="hatsuchiYmdFrom"
                          :readonly="false"
                          />
                      </div>
                      <div style="width:6%" class="mt-2 mp-0">～</div>
                      <div style="width:47%" class="px-1">
                        <dd-date-box
                          v-model="conditions.hatsuchiYmdTo"
                          ref="hatsuchiYmdTo"
                          :readonly="false"
                          />
                      </div>
                    </v-row>
                  </v-col>
                  <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="荷主コード/名称"
                          v-model="conditions.ninushi"
                          ref="ninushi"
                          :length="100"
                          :readonly="false"
                          :valueType="Ctrls.InputTypes.Alphanumeric"
                          titleText="荷主検索"
                          :headerList="torihikisakiHeader"
                          item-value="torihikisakiCd"
                          item-text="torihikisakiNm"
                          :itemList="filteredMstTorihikisakiList"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-toolbar class="pa-0 ma-0" flat dense>
                        <v-spacer />
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onSearchButtonClick">
                          検索
                        </dd-default-button>
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onClearButtonClick">
                          クリア
                        </dd-default-button>
                      </v-toolbar>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters align-content="center">
            <v-col :cols="6">
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="検索結果"
                v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="絞込結果"
                v-model="filteredRowCount"/>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                :height="calcHeightTable"
                item-key="id"
                showSelect
                @dblclick:row="onRowDoubleClick"
                @click:row="onRowClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                :itemsPerPage=500
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseClick">
          閉じる
        </dd-footer-button>
        <v-spacer></v-spacer>
        <dd-footer-button
          :disabled="isSelectButtonDisabled"
          @click="onSelectButtonClick">
          選択
        </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import controls from '@/rahmen/controls'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'

import { mapGetters } from 'vuex'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdDateBox = () => import('@/components/DdDateBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')

export default {
  name: 'ThNippoKamotsuSearchDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdDateBox,
    DdCodeTextBox,
    DdDataTable,
    DdRowCountBox,
    DdDefaultButton,
    DdNarrowDownTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String
  },
  data: () => ({
    conditions: {
      eigyosho: '',
      hatsuchiYmdFrom: '',
      hatsuchiYmdTo: '',
      ninushi: ''
    },
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: [],
    /*
     *
     */
    headers: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '貨物No', value: 'juchuNo' },
      { text: '営業所', value: 'wEigyoshoCdNm' },
      { text: '荷主', value: 'wNinushiCdNm' },
      { text: '発地', value: 'wHatsuchiCdNm' },
      { text: '卸先', value: 'wOroshisakiCdNm' },
      { text: '着地', value: 'wChakuchiCdNm' },
      { text: '積日', value: 'hatsuchiYmd' },
      { text: '請求金額', value: 'seikyuKingaku', align: 'right' },
      { text: '売上金額', value: 'uriageKingaku', align: 'right' }
    ],
    page: 1
  }),
  created () {
    console.log('screen created')
    this.$store.dispatch('system/setViewTitle', '受注検索')
    this.eigyoshoHeader = header.mstEigyoshoHeaders
    this.torihikisakiHeader = header.mstTorihikisakiHeaders
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/mstJinin',
      sharyoList: 'DDMasters/vwCMstSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki'
    }),
    // 営業所マスタフィルター --> ここから
    filteredMstEigyosho () {
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstEigyosho.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === false
      })
    },
    // 貨物検索行データ
    filteredRows () {
      // データがない場合の制御
      if (!this.rows.map) return

      return this.rows.map((elem) => {
        elem.wEigyoshoCdNm = elem.eigyoshoCd + ' : ' + elem.eigyoshoNm
        if (elem.ninushiCd && elem.ninushiNm) {
          elem.wNinushiCdNm = elem.ninushiCd + ' : ' + elem.ninushiNm
        } else {
          elem.wNinushiCdNm = elem.ninushiCd ? elem.ninushiCd : '' + elem.ninushiNm ? elem.ninushiNm : ''
        }

        if (elem.hatsuchiCd && elem.hatsuchiNm) {
          elem.wHatsuchiCdNm = elem.hatsuchiCd + ' : ' + elem.hatsuchiNm
        } else {
          elem.wHatsuchiCdNm = elem.hatsuchiCd ? elem.hatsuchiCd : '' + elem.hatsuchiNm ? elem.hatsuchiNm : ''
        }

        if (elem.oroshisakiCd && elem.oroshisakiNm) {
          elem.wOroshisakiCdNm = elem.oroshisakiCd + ' : ' + elem.oroshisakiNm
        } else {
          elem.wOroshisakiCdNm = elem.oroshisakiCd ? elem.oroshisakiCd : '' + elem.oroshisakiNm ? elem.oroshisakiNm : ''
        }

        if (elem.chakuchiCd && elem.chakuchiNm) {
          elem.wChakuchiCdNm = elem.chakuchiCd + ' : ' + elem.chakuchiNm
        } else {
          elem.wChakuchiCdNm = elem.chakuchiCd ? elem.chakuchiCd : '' + elem.chakuchiNm ? elem.chakuchiNm : ''
        }

        if (elem.hatsuchiYmd) {
          elem.hatsuchiYmd = filter.dateFormatter(elem.hatsuchiYmd)
        }
        if (elem.seikyuKingaku) {
          elem.seikyuKingaku = filter.numericFormatter(String(elem.seikyuKingaku))
        }
        if (elem.uriageKingaku) {
          elem.uriageKingaku = filter.numericFormatter(String(elem.uriageKingaku))
        }
        return elem
      })
    },
    // 取引先マスタフィルター <-- ここまで
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isSelectButtonDisabled () {
      return this.selectedItem.length === 0
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.45
      }
      return this.tableHeight * 0.34
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      // /* eslint no-debugger: "warn" */
      // debugger
      const opt = {
        loadMasters: ['mstjinin', 'msttorihikisaki', 'msteigyosho', 'mstsharyo'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThNippoKamotsuSearchDialog.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          this.conditions.eigyosho = c.nippoKamotsuEigyosho !== undefined && c.nippoKamotsuEigyosho !== '' && c.nippoKamotsuEigyosho !== null ? c.nippoKamotsuEigyosho : ''
          this.conditions.hatsuchiYmdFrom = c.nippoKamotsuHatsuchiYmdFrom !== undefined && c.nippoKamotsuHatsuchiYmdFrom !== '' && c.nippoKamotsuHatsuchiYmdFrom !== null ? c.nippoKamotsuHatsuchiYmdFrom : ''
          this.conditions.hatsuchiYmdTo = c.nippoKamotsuHatsuchiYmdTo !== undefined && c.nippoKamotsuHatsuchiYmdTo !== '' && c.nippoKamotsuHatsuchiYmdTo !== null ? c.nippoKamotsuHatsuchiYmdTo : ''
          this.conditions.ninushi = c.nippoKamotsuNinushi !== undefined && c.nippoKamotsuNinushi !== '' && c.nippoKamotsuNinushi !== null ? c.nippoKamotsuNinushi : ''

          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThNippoKamotsuSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('ThNippoKamotsuSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            // this.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThNippoKamotsuSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThNippoKamotsuSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            conditions: this.conditions
          }
        },
        settingViewScroll: () => {
          return true
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      // /* eslint no-debugger: "warn" */
      // debugger
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      // this.$emit('close', f.item)
      this.$emit('close', this.selectedItem)
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      // this.clear(false)
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      console.log('row clicked', e, this.searchText)
      this.selectedItem = [e]
      /*
      if (this.selectedItem.length === 0) {
        this.selectedItem = [e]
      } else {
        this.selectedItem = []
      }
      */
    },
    onSelectButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem)
      }
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      // this.clear(false)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VWCTHPRMD00104/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChacheById('THPRMD0010', cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            nippoKamotsuEigyosho: self.conditions.eigyosho ? self.conditions.eigyosho : '',
            nippoKamotsuHatsuchiYmdFrom: self.conditions.hatsuchiYmdFrom ? self.conditions.hatsuchiYmdFrom : '',
            nippoKamotsuHatsuchiYmdTo: self.conditions.hatsuchiYmdTo ? self.conditions.hatsuchiYmdTo : '',
            nippoKamotsuNinushi: self.conditions.ninushi ? self.conditions.ninushi : ''
          }
        }
      }
      this.search(opt)
    },
    clear: function (isRemainRows) {
      console.log('clear', this.torihikisakiList)
      return new Promise(resolve => {
        this.initBindVariables()
        if (!isRemainRows) {
          this.rows = []
          this.searchText = ''
          this.selectedItem = []
        }
        resolve()
      })
    },
    clearExec: function () {
      console.log('clearExec')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.searchText = ''
        this.rows = []
        this.selectedItem = []
      })
      this.Effects.loadComplete()
    },
    onClearButtonClick: function (e) {
      /**
       * クリアボタン押下処理
       * @event click
       * @type {Event}
       */
      this.Effects.loadStart()
      this.clearExec()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      // this.clear(false)
    },
    searchValidate: function () {
      var msg
      if (this.conditions.hatsuchiYmdFrom && this.conditions.hatsuchiYmdTo) {
        msg = validators.compareDate(this.conditions.hatsuchiYmdFrom, this.conditions.hatsuchiYmdTo)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmdFrom[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.hatsuchiYmdTo[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        eigyosho: '',
        hatsuchiYmdFrom: '',
        hatsuchiYmdTo: '',
        ninushi: ''
      }
    },
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * 別途共通関数待
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    convertFormatToHHMM: function (val) {
      if (val.length < 5) return val
      return val.substr(0, 5)
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 400 !important;
}
</style>
